<template>
	<div class="school-structure">
		<div class="page__header">
			<h1 class="school-structure__title">School Structure</h1>
		</div>
		<div class="page__content--overlap">
			<div class="school-structure__schools">
				<table class="school-structure__schools__table">
					<tr
						class="school-structure__school"
						v-for="school in schools"
						:key="school.id">
						<td>
							<input class="school-structure__school__name" type="text" placeholder="Name" v-model="school.name">
						</td>
						<td>
							<button class="school-structure__school__delete" type="button" @click="deleteSchool(school)">
								<i class="fas fa-trash-alt"></i>
								Delete School
							</button>
						</td>
					</tr>
					<tr>
						<td>
							<input class="school-structure__school__name" type="text" placeholder="Name" v-model="newSchool.name">
						</td>
						<td>
							<button
								class="school-structure__school__add"
								type="button"
								@click="addSchool(newSchool)">
								Add School
							</button>
						</td>
					</tr>
				</table>
			</div>
			<div class="school-structure__programs">
				<select
					@change="chooseSchool()"
					class="school-structure__programs__school"
					v-model="school">
					<option
						:value="school"
						:key="school.id"
						v-for="school in schools">
						{{school.name}}
					</option>
				</select>
				<table class="school-structure__programs__table" v-if="school">
					<tr
						class="school-structure__program"
						v-for="program in programs"
						:key="program.id">
						<td>
							<input class="school-structure__program__icon" type="text" placeholder="Icon" v-model="program.icon">
						</td>
						<td>
							<input class="school-structure__program__title" type="text" placeholder="Title" v-model="program.title">
						</td>
						<td>
							<button class="school-structure__program__delete" type="button" @click="deleteProgram(program)">
								<i class="fas fa-trash-alt"></i>
								Delete Program
							</button>
						</td>
					</tr>
					<tr>
						<td>
							<input class="school-structure__program__icon" type="text" placeholder="Icon" v-model="newProgram.icon">
						</td>
						<td>
							<input class="school-structure__program__title" type="text" placeholder="Title" v-model="newProgram.title">
						</td>
						<td>
							<button
								class="school-structure__program__add"
								type="button"
								@click="addProgram(newProgram)">
								Add Program
							</button>
						</td>
					</tr>
				</table>
			</div>
			<div class="school-structure__courses" v-if="school">
				<select
					@change="chooseProgram()"
					class="school-structure__courses__program"
					v-model="program">
					<option
						:value="program"
						:key="program.id"
						v-for="program in programs">
						{{program.title}}
					</option>
				</select>
				<table class="school-structure__courses__table" v-if="program">
					<tr
						class="school-structure__course"
						v-for="course in coursesSorted"
						:key="course.id">
						<td>
							<button class="school-structure__course__update" type="button" @click="editCourse(course)">
								Update Course
							</button>
						</td>
						<td>
							<input class="school-structure__course__year" type="text" placeholder="Year" v-model="course.year">
						</td>
						<td>
							<input class="school-structure__course__period" type="text" placeholder="Period" v-model="course.period">
						</td>
						<td>
							<input class="school-structure__course__icon" type="text" placeholder="Icon" v-model="course.icon">
						</td>
						<td>
							<input class="school-structure__course__title" type="text" placeholder="Title" v-model="course.title">
						</td>
						<td>
							<button class="school-structure__course__delete" type="button" @click="deleteCourse(course)">
								<i class="fas fa-trash-alt"></i>
								Delete Course
							</button>
						</td>
					</tr>
					<tr>
						<td>
						</td>
						<td>
							<input class="school-structure__course__year" type="text" placeholder="Year" v-model="newCourse.year">
						</td>
						<td>
							<input class="school-structure__course__period" type="text" placeholder="Period" v-model="newCourse.period">
						</td>
						<td>
							<input class="school-structure__course__icon" type="text" placeholder="Icon" v-model="newCourse.icon">
						</td>
						<td>
							<input class="school-structure__course__title" type="text" placeholder="Title" v-model="newCourse.title">
						</td>
						<td>
							<button
								class="school-structure__course__add"
								type="button"
								@click="addCourse(newCourse)">
								Add Course
							</button>
						</td>
					</tr>
				</table>
			</div>
		</div>
	</div>
</template>

<script>
import AdminService from '@/services/AdminService'
import SchoolService from '@/services/SchoolService'
export default {
	props: {
		tasks: Array
	},
	data () {
		return {
			newSchool: {},
			newProgram: {},
			newCourse: {},
			school: null,
			program: null,
			course: null,
			schools: [],
			programs: [],
			courses: []
		}
	},
	methods: {
		async getSchools () {
			this.schools = await SchoolService.getSchools()
		},
		async getPrograms () {
			this.programs = await SchoolService.getPrograms(this.school.id)
		},
		async getCourses () {
			this.courses = await SchoolService.getCourses(this.program.id)
		},
		async addSchool () {
			await AdminService.addSchool(this.newSchool)
			this.getSchools()
			this.newSchool = {}
		},
		async deleteSchool (school) {
			if (!confirm('Are you sure you want to delete this school?')) return
			await AdminService.deleteSchool(school.id)
			this.getSchools()
		},
		async chooseSchool () {
			this.getPrograms()
			this.program = null
		},
		async chooseProgram () {
			this.getCourses()
			this.course = null
		},
		async addProgram () {
			var program = this.newProgram
			program.school = this.school.id
			await AdminService.addProgram(program)
			this.getPrograms()
			this.newProgram = {}
		},
		async deleteProgram (program) {
			if (!confirm('Are you sure you want to delete this program?')) return
			await AdminService.deleteProgram(program.id)
			this.getPrograms()
		},
		async addCourse () {
			var course = this.newCourse
			course.program = this.program.id
			await AdminService.addCourse(course)
			this.getCourses()
			this.newCourse = {}
		},
		async deleteCourse (course) {
			if (!confirm('Are you sure you want to delete this course?')) return
			await AdminService.deleteCourse(course.id)
			this.getCourses()
		},
		async editCourse (course) {
			if (!confirm('Are you sure you wish to update this course?')) return
			await AdminService.editCourse(course)
		}
	},
	computed: {
		coursesSorted () {
			const courses = this.courses
			const coursesSorted = courses.sort(function (a, b) {
				if (a.year === b.year) {
					return a.period - b.period
				}
				return a.year > b.year ? 1 : -1
			})
			return coursesSorted
		}
	},
	async created () {
		this.getSchools()
	}
}
</script>

<style lang="scss" scoped>
@import "@/styles/views/admin/_school-structure.scss";
</style>
